import { render, staticRenderFns } from "./AppEmptyList.vue?vue&type=template&id=64f71094&scoped=true"
import script from "./AppEmptyList.vue?vue&type=script&lang=js"
export * from "./AppEmptyList.vue?vue&type=script&lang=js"
import style0 from "./AppEmptyList.vue?vue&type=style&index=0&id=64f71094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f71094",
  null
  
)

export default component.exports